import classNames from 'classnames/bind';
import { func, string } from 'prop-types';
import React, { Fragment, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { ReactComponent as Arrow } from './assets/arrow.svg';
import { actionTypes } from '../../store/actions/imageModal';
import { dateFormatRU } from '../../utils';

import Modal from '../Modal';
import Button from '../Button';
import UserIcon from '../UserIcon';

import s from './index.module.css';
import { getImageModalCurrentImage, getImageModalItems, getImageModalShow } from '../../store/selectors';

const cx = classNames.bind(s);

const ImagesModal = () => {
  const currentImage = useSelector(getImageModalCurrentImage);
  const items = useSelector(getImageModalItems);
  const isShow= useSelector(getImageModalShow);
  const dispatch = useDispatch();

  const close = useCallback(() => dispatch({ type: actionTypes.CLOSE }), [dispatch]);

  const open = useCallback((payload) => dispatch({ type: actionTypes.OPEN, payload }), [dispatch]);

  if (!isShow || !currentImage) {
    return null;
  }

  const currentIndex = items.indexOf(currentImage);
  const { attachment, timestamp, sender } = currentImage;
  const date = new Date(timestamp);
  const time = dateFormatRU(date, 'H:MM');
  const day = date.toLocaleDateString('ru-Ru', {
    day: 'numeric',
    month: 'long',
  });

  const next = items[currentIndex + 1];
  const previous = items[currentIndex - 1];

  return (
    <Fragment>
      <Modal className={s.modal} wrapperClassName={s.modalWrapper} onClose={close} overlayClick={() => {}} showClose>
        <div className={s.modalBody}>
          {previous && (
            <Button className={cx(s.leftButton, s.button)} onClick={() => open(previous)}>
              <Arrow width={20} height={40} />
            </Button>
          )}

          <img className={s.image} src={attachment} alt="" />

          {next && (
            <Button className={cx(s.rightButton, s.button)} onClick={() => open(next)}>
              <Arrow width={20} height={40} />
            </Button>
          )}

          <div className={s.footer}>
            <UserIcon className={s.icon} icon={sender && sender.picture_path} />
            <div className={s.info}>
              <span>{sender && sender.name}</span>
              <span>
                {day}, {time}
              </span>
            </div>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

ImagesModal.propTypes = {
  className: string,
  onPost: func,
};

ImagesModal.defaultProps = {
  className: null,
  onPost: () => {},
};

export default ImagesModal;
